/**
 * Created by Vladislav on 25.09.2024.
 */

const WorkersMenuBarItem = {
    name: "WorkersItem",
    plusButton: true,
    targets: "worker",
    timerTTF: true,
    viewClass: MenuBarWithTimeoutView,
    modelClass: WorkersMenuBarItemModel,
    sparks: true,
    attention: function () {
        return typeof Map2d !== "undefined" && Map2d.currentMap && Map2d.currentMap.workers.isAdsWorkerAvailable()
            && cleverapps.adsLimits.state(AdsLimits.TYPES.WORKER) === AdsLimits.STATE_READY && cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_ADS;
    },
    onClickWindow: () => BonusWorkerWindow,
    icon: function () {
        if (WorkersMenuBarItem.UseSubscriptionView()) {
            return bundles.menubar.frames.merge_subscription_worker_png;
        }
        return cleverapps.skins.getSlot("merge_worker_png") || bundles.menubar.frames.merge_worker_png;
    },
    availableOnScenes: function () {
        const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
        if (locationConfig.usesWorkers && locationConfig.usesWorkers.bonusWorkers) {
            return [cleverapps.Environment.SCENE_MAIN];
        }
    },
    incEffect: "menubar.worker.fly_finish",
    decEffect: "menubar.worker.fly_finish",
    sticker: function () {
        if (WorkersMenuBarItem.UseSubscriptionView()) {
            return "premium";
        }
    }
};

WorkersMenuBarItem.UseSubscriptionView = function () {
    return cleverapps.meta.getSelectedLocation().locationConfig.isMain && Subscription.IsAvailable() && cleverapps.subscription.isActive();
};